<template>
  <div class="bbs-template" theme-bbs>
    <div id="theme-bbs-header" />
    <div id="theme-bbs-leftside" />
    <div id="theme-bbs-content">
      <div v-show="mountedMode === 'list'" id="theme-bbs-content-list" />
      <div v-show="mountedMode === 'create'" id="theme-bbs-content-create" />
      <div v-show="mountedMode === 'update'" id="theme-bbs-content-update" />
      <div v-show="mountedMode === 'detail'" id="theme-bbs-content-detail" />
    </div>
    <div id="theme-bbs-rightside" />
    <div id="theme-bbs-footer" />
    <b-modal
      id="save-bbsctt-confirm-modal"
      ref="saveBbscttConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="saveBbsctt($event)"
    >
      <p class="my-4" v-html="$t('common.modal.text.update_confirm')" />
    </b-modal>
    <b-modal
      id="delete-bbsctt-confirm-modal"
      ref="deleteBbscttConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="deleteBbsctt($event)"
    >
      <p class="my-4" v-html="$t('common.modal.text.delete_confirm')" />
      <input v-if="!loggedInUser && targetBbsctt" style="display:none" type="text" name="faketextremembered">
      <input v-if="!loggedInUser && targetBbsctt" style="display:none" type="password" name="fakepasswordremembered">
      <input-control v-if="!loggedInUser && targetBbsctt" v-model="targetBbsctt.pwd" type="password" :title="$t('column.nm.pwd')" name="pwd" />
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    isGroup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      targetBbsctt: undefined,
      path: 'bbs',
      parts: [
        {
          elem: '#theme-bbs-header',
          htmlFile: 'header'
        },
        {
          elem: '#theme-bbs-leftside',
          htmlFile: 'leftside'
        },
        {
          elem: '#theme-bbs-rightside',
          htmlFile: 'rightside'
        },
        {
          elem: '#theme-bbs-footer',
          htmlFile: 'footer'
        }
      ],
      mountedMode: ''
    }
  },
  watch: {
    '$route.query.mode': {
      handler(newVal, oldVal) {
        if (!newVal) {
          this.$router.replace(this.$route.path + '?mode=list')
          this.mountedMode = 'list'
        } else {
          this.mountedMode = this.$route.query.mode
          if (this.bbs) {
            this.loadHtml()
          } else {
            this.loadBbs()
          }
        }
        this.$eventHub.$emit('mode-changed')
      },
      immediate: true
    },
    mountedMode(newVal, oldVal) {
      if (!oldVal) {
        return
      }
      let elem = 'html'
      if ($('body').scrollTop() > 0) {
        elem = 'body'
      }
      setTimeout(() => {
        $(elem).animate(
          {
            scrollTop: '0px'
          },
          200
        )
      }, 100)
    }
  },
  mounted() {
    if (!this.$route.query.mode && this.$route.query.id) {
      this.$router.replace(
        this.$route.path + '?mode=detail&id=' + this.$route.query.id
      )
    } else if (!this.$route.query.mode) {
      this.$router.replace(this.$route.path + '?mode=list')
    }
    this.$eventHub.$on('save-item-confirm', this.onSaveItemConfirm)
    this.$eventHub.$on('delete-item-confirm', this.onDeleteItemConfirm)
  },
  beforeDestroy() {
    this.$eventHub.$off('save-item-confirm', this.onSaveItemConfirm)
    this.$eventHub.$off('delete-item-confirm', this.onDeleteItemConfirm)
    // if (window.device && window.device.enableCapture) {
    //   if (process && process.env && process.env.env !== 'production') {
    //     window.device.enableCapture()
    //   } else {
    //     window.device.disableCapture()
    //   }
    // }
  },
  methods: {
    deleteBbsctt() {
      let url = 'bbs/public/bbsctt?id=' + this.targetBbsctt.id
      if (this.targetBbsctt.pwd) {
        url += '&pwd=' + this.targetBbsctt.pwd
      }
      this.$axios.$delete(url).then(response => {
        if (response.resultCode === 'success') {
          this.$eventHub.$emit('item-deleted', {
            item: response.data,
            componentId: this.getMainComponentId()
          })
          const query = window.copyObject(this.$route.query)
          query.mode = 'list'
          this.$router.push({
            path: this.$router.currentRoute.path,
            query: query
          })
        } else {
          console.error(this.$t(response.message, response.params))
          this.$toast.error(this.$t(response.message, response.params))
        }
      })
    },
    saveBbsctt() {
      this.$axios
        .$post('bbs/public/bbsctt', this.targetBbsctt)
        .then(response => {
          if (response.resultCode === 'success') {
            this.$eventHub.$emit('item-saved', {
              item: response.data,
              componentId: this.getMainComponentId()
            })
            const query = window.copyObject(this.$route.query)
            query.mode = 'list'
            this.$router.push({
              path: this.$router.currentRoute.path,
              query: query
            })
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
    },
    onDeleteItemConfirm(params) {
      this.targetBbsctt = params.item
      this.showModal('deleteBbscttConfirmModalRef')
    },
    onSaveItemConfirm(params) {
      let validated = true
      const self = this
      $(this.$el)
        .find('[data-vv-as]')
        .each(function() {
          $(this).blur()
          self.$validator.validate($(this).attr('name'))
        })
      this.$nextTick(() => {
        this.$nextTick(() => {
          $(this.$el)
            .find('.show-invalid')
            .each(function() {
              if (!$(this).val()) {
                validated = false
                self.$toast.error($(this).text())
                if ($(this).closest('.input-control').length > 0) {
                  $('html').animate(
                    {
                      scrollTop:
                        $(this)
                          .closest('.input-control')
                          .offset().top - 70
                    },
                    400,
                    'swing',
                    () => {
                      $(this)
                        .closest('.input-control')
                        .animate(
                          {
                            opacity: 0.4
                          },
                          200,
                          'swing',
                          () => {
                            $(this)
                              .closest('.input-control')
                              .animate(
                                {
                                  opacity: 1
                                },
                                200,
                                'swing'
                              )
                          }
                        )
                    }
                  )
                }
              }
              if (!validated) {
                return false
              }
            })
          if (validated) {
            this.targetBbsctt = params.item
            this.targetBbsctt.bbsId = params.bbs.id
            this.showModal('saveBbscttConfirmModalRef')
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.bbs-template {
  min-height: 100px;
}
</style>
